import React from "react";
import { useTranslation } from "react-i18next";
import { SharedEventList } from "./sharedEventList";

/**
 * HSE/KS Accidents List - Accidents (HMS)
 */
export const HseKsAccidentsList = () => {
  const { t } = useTranslation();

  return (
    <SharedEventList
      activeTab="accidents"
      title="Ulykker"
      subtitle="Oversikt over ulykker (HMS - ISO 45001)"
      newButtonLabel={t("Ny ulykke")}
      newButtonPath="/dashboard/hse-ks/events/new?type=accident"
      emptyMessage={t("Ingen ulykker funnet")}
      searchPlaceholder={t("Søk i ulykker...")}
      defaultFilters={{
        event_type: "injury",
      }}
    />
  );
};

